import {Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {
  countriesInfosAndCurrencyMock$,
  CountryInfosAndCurrencyModel
} from '../../../../../common/mocks/countries-infos-and-currency-mock';
import {IonSearchbar, ModalController, NavParams} from '@ionic/angular';

@Component({
  selector: 'app-country-selector',
  templateUrl: './country-selector.component.html',
  styleUrls: ['./country-selector.component.scss'],
})
export class CountrySelectorComponent implements OnInit {
  @ViewChild('searchbar') searchbar: IonSearchbar;
  defaultCountryData: CountryInfosAndCurrencyModel[] = countriesInfosAndCurrencyMock$;
  autocompleteInput: string;
  autocompleteOutput: CountryInfosAndCurrencyModel[] = [];

  constructor(private ngZone: NgZone, private modalCtrl: ModalController, private navParams: NavParams) {
    this.autocompleteInput = navParams.get('inputValue') ? navParams.get('inputValue') : '';
    this.updateSearchResults();
  }

  ionViewDidEnter() {
    setTimeout(() => {
      this.searchbar.setFocus();
    }, 500);
  }

  ngOnInit() {}

  updateSearchResults() {
    const that = this;
    this.ngZone.run(() => {
      this.autocompleteOutput = this.defaultCountryData
        .filter( countriesInfosAndCurrency => countriesInfosAndCurrency.french_name !== undefined
            ? countriesInfosAndCurrency.french_name.toLowerCase().includes(that.autocompleteInput.toLowerCase()) : [])
        .sort( (countryInfosAndCurrencyA, countryInfosAndCurrencyB) => {
          if (countryInfosAndCurrencyA.french_name < countryInfosAndCurrencyB.french_name) { return -1; }
          if (countryInfosAndCurrencyA.french_name > countryInfosAndCurrencyB.french_name) { return 1; }
          return 0;
        });
    });
  }

  clear() {
    this.autocompleteInput = '';
    this.autocompleteOutput = [];
  }

  close() {
    this.modalCtrl.dismiss();
  }

  selectSearchResult(selectedCountry: CountryInfosAndCurrencyModel) {
    this.modalCtrl.dismiss(selectedCountry);
  }

}
